// const eeds = require('./eeds.json')
// const xian = require('./xian.json')
import eeds from './eeds.json';
import xian from './xian.json';
const xianCdata = [
    {
        name: '西安市',
        value: 10
    },
    {
        name: '铜川市',
        value: 9
    },
    {
        name: '宝鸡市',
        value: 8
    },
    {
        name: '咸阳市',
        value: 7
    },
    {
        name: '渭南市',
        value: 6
    },
    {
        name: '延安市',
        value: 5
    },
    {
        name: '汉中市',
        value: 4
    },
    {
        name: '榆林市',
        value: 3
    },
    {
        name: '安康市',
        value: 2
    },
    {
        name: '商洛市',
        value: 1
    }
]
let xianSeriesData = [
    {
        name: '西安市'
    },
    {
        name: '铜川市'
    },
    {
        name: '宝鸡市'
    },
    {
        name: '咸阳市'
    },
    {
        name: '渭南市'
    },
    {
        name: '延安市'
    },
    {
        name: '汉中市'
    },
    {
        name: '榆林市'
    },
    {
        name: '安康市'
    },
    {
        name: '商洛市'
    }
];
const xianGeoCoordMap = {
    西安市: [108.948024,34.263161, 20],
    铜川市: [108.979608,34.916582, 20],
    宝鸡市: [107.14487,34.369315, 20],
    咸阳市: [108.705117,34.333439, 20],
    渭南市: [109.502882,34.499381, 20],
    延安市: [109.49081,36.596537, 20],
    汉中市: [107.028621,33.077668, 20],
    榆林市: [109.741193,38.290162, 20],
    安康市: [109.029273,32.6903, 20],
    商洛市: [109.939776,33.868319, 20],
};

const eedsCdata = [
    {
        name: '呼和浩特市',
        value: 10
    },
    {
        name: '包头市',
        value: 9
    },
    {
        name: '乌海市',
        value: 8
    },
    {
        name: '赤峰市',
        value: 7
    },
    {
        name: '通辽市',
        value: 6
    },
    {
        name: '鄂尔多斯市',
        value: 5
    },
    {
        name: '呼伦贝尔市',
        value: 4
    },
    {
        name: '巴彦淖尔市',
        value: 3
    },
    {
        name: '乌兰察布市',
        value: 2
    },
    {
        name: '兴安盟',
        value: 1
    },
    {
        name: '锡林郭勒盟',
        value: 12
    },
    {
        name: '阿拉善盟',
        value: 13
    }
]
let eedsSeriesData = [
    {
        name: '呼和浩特市'
    },
    {
        name: '包头市'
    },
    {
        name: '乌海市'
    },
    {
        name: '赤峰市'
    },
    {
        name: '通辽市'
    },
    {
        name: '鄂尔多斯市'
    },
    {
        name: '呼伦贝尔市'
    },
    {
        name: '巴彦淖尔市'
    },
    {
        name: '乌兰察布市'
    },
    {
        name: '兴安盟'
    },
    {
        name: '锡林郭勒盟'
    },
    {
        name: '阿拉善盟'
    }
];
const eedsGeoCoordMap = {
    呼和浩特市: [111.670801,40.818311, 20],
    包头市: [109.840405,40.658168, 20],
    乌海市: [106.825563, 39.673734, 20],
    赤峰市: [118.956806,42.275317, 20],
    通辽市: [122.263119,43.617429, 20],
    鄂尔多斯市: [109.99029,39.817179, 20],
    呼伦贝尔市: [119.758168,49.215333, 20],
    巴彦淖尔市: [107.416959,40.757402, 20],
    乌兰察布市: [113.114543,41.034126, 20],
    兴安盟: [122.070317,46.076268, 20],
    锡林郭勒盟: [116.090996,43.944018, 20],
    阿拉善盟: [105.706422,38.844814, 20]
};

// console.log(xianCdata, eedsCdata)
// console.log(xianSeriesData, eedsSeriesData)
// console.log(xianGeoCoordMap, eedsGeoCoordMap)
export default {
    '610000': {
        cdata: xianCdata,
        seriesData: xianSeriesData,
        geoCoordMap: xianGeoCoordMap,
        data: xian,
        businessList: [
            {name: '西安市', value: [108.948024,34.263161]},
            {name: '渭南市', value: [109.502882,34.4993811]}
        ]
    },
    '150000': {
        cdata: eedsCdata,
        seriesData: eedsSeriesData,
        geoCoordMap: eedsGeoCoordMap,
        data: eeds,
        businessList: [
            {name: '鄂尔多斯市', value: [109.99029,39.817179]}
        ]
    }
}